import clsx from 'clsx';
import React from 'react';

import Byline from '@components/Byline';
import ArticleHeader from '@components/FeedItems/ArticleHeader';
import ArticleImage from '@components/FeedItems/ArticleImage';
import Highlight from '@components/FeedItems/Highlight';
import useEventTracking from '@hooks/useEventTracking';
import { Article } from '@interfaces/homepage';
import { ContentType } from '@tracking';

interface ArticleItemProps {
  article: Article;
  offerCode?: string;
}

const ArticleItem = ({ article, offerCode }: ArticleItemProps) => {
  const { id, picture, slug, title, highlight, authors, isPro } = article;
  const { Track } = useEventTracking({
    contentId: id,
    contentType: ContentType.Article,
  });
  return (
    <Track>
      <div className="flex gap-0 sm:gap-12 md:block md:flex-1">
        <ArticleImage
          className="hidden aspect-[16/9] !h-auto w-[180px] sm:block"
          id={id}
          isPro={isPro}
          picture={picture}
          sizes="180px"
          slug={slug}
          title={title}
          offerCode={offerCode}
        />
        <div>
          {highlight && (
            <Highlight
              highlight={highlight}
              className="!mb-0 mt-10 font-suisse-intl-mono text-overline-sm sm:mt-0 sm:!text-caption-sm"
            />
          )}
          <ArticleHeader
            className={clsx('text-body-md font-normal sm:text-body-lg', { 'mt-10': !highlight })}
            title={title}
            slug={slug}
            offerCode={offerCode}
          />
          <Byline authors={authors} />
        </div>
      </div>
    </Track>
  );
};

export default ArticleItem;
